



import React, { useContext, useState, useEffect } from 'react';

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';
import { MdStar, MdStarBorder } from "react-icons/md";
import IconButton from '@mui/material/IconButton';
import Container from "@mui/material/Container";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import PropTypes from 'prop-types'; import TextField from "@mui/material/TextField";

import CloseIcon from '@mui/icons-material/Close';

import { UserManagementContext } from '../../pages/Counter2';

import { PatternFormat } from 'react-number-format';

import { useForm, Controller } from "react-hook-form";




import { useParams, useNavigate, Navigate, Link } from "react-router-dom";

import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SearchIcon from '@mui/icons-material/Search';


import { GraphDetailsContext, ProjectDashboardContext } from '../../App';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { NumericFormat } from 'react-number-format';
import Chip from '@mui/material/Chip';
import dayjs from 'dayjs';

import CircularProgress, {
    CircularProgressProps,
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Divider from '@mui/material/Divider';

import { loginRequest, b2cPolicies } from "../../authConfig";
import { useMsal, MsalAuthenticationTemplate, useIsAuthenticated } from '@azure/msal-react';
import { InteractionType, InteractionStatus, InteractionRequiredAuthError } from '@azure/msal-browser';
import { HiOutlineTrash } from "react-icons/hi";

import useFetchTimelines from "../../hooks/useFetchTimelines";



const LightTooltipTimeline = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        maxWidth: 220,
    },
}));

function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', ml: '1VW', mr: "1vw", mt: '-3VH' }}>
            <CircularProgress
                variant="determinate"
                sx={(theme) => ({
                    color: theme.palette.grey[200],
                    ...theme.applyStyles('dark', {
                        color: theme.palette.grey[800],
                    }),
                })}
                size={"5.5rem"}
                thickness={4}
                {...props}
                value={100}
            />
            <CircularProgress size="5.5rem" thickness={4} disableShrink sx={{}} variant="determinate" {...props} sx={{ position: 'absolute', }}
                sx={(theme) => ({
                    color: '#0059a8',
                    animationDuration: '0ms',
                    position: 'absolute',
                    left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                        strokeLinecap: 'round',
                    },
                    ...theme.applyStyles('dark', {
                        color: '#308fe8',
                    }),
                })}
            />
            <Box
                sx={{
                    top: "-4VH",
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',

                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: 'text.primary', ml: 'VW', fontWeight: "600", fontSize: "1.25rem", position: "absolute" }}
                >{`${Math.round(props.value)}%`}</Typography>
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: 'text.secondary', ml: '-0.05VW', mt: "4VH", textAlign: "center", fontWeight: "300", fontSize: "0.9rem", position: "absolute" }}
                >{`Response`}</Typography>
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: 'text.secondary', ml: '-0.05VW', mt: "7VH", textAlign: "center", fontWeight: "300", fontSize: "0.9rem", position: "absolute" }}
                >{`Rate`}</Typography>
            </Box>
        </Box>
    );
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #60A5FA",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#EFF6FF",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#60A5FA',
        ...theme.applyStyles('dark', {
            backgroundColor: '#308fe8',
        }),
    },
}));

const BorderLinearProgressRed = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #EF4444",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#EF4444",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#EF4444',
        ...theme.applyStyles('dark', {
            backgroundColor: '#308fe8',
        }),
    },
}));

const BorderLinearProgressBlack = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #000000DE",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#000000DE",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#000000DE',
        ...theme.applyStyles('dark', {
            backgroundColor: '#000000DE',
        }),
    },
}));

const BorderLinearProgressTeal = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #B6EFE4",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#B6EFE4",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#B6EFE4',
        ...theme.applyStyles('dark', {
            backgroundColor: '#B6EFE4',
        }),
    },
}));

const BorderLinearProgressTealTwo = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #2DD4BF",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#EFF6FF",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#2DD4BF',
        ...theme.applyStyles('dark', {
            backgroundColor: '#2DD4BF',
        }),
    },
}));

const BorderLinearProgressGoldOne = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #F6BE00",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#F6BE00",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#F6BE00',
        ...theme.applyStyles('dark', {
            backgroundColor: '#F6BE00',
        }),
    },
}));

const BorderLinearProgressGoldTwo = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    border: "solid 1px #FCE587",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#FCE587",
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,






        backgroundColor: '#FCE587',
        ...theme.applyStyles('dark', {
            backgroundColor: '#FCE587',
        }),
    },
}));

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const materialUITextFieldProps = {
    sx: [{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }],
    variant: "outlined"
};

function EditTimelineCard({ cardTitle, cardSubtitle, desiredCardWidth, desiredCardHeight, desiredHeightPercentage, cardType, cardChipLabel, cardChipStatus, cardExtraSubtitle, cardMilestoneData, cardBatchEndDate, cardExtraSubtitle2, cardFamilyStartId, cardFamilyEndId, cardTotalCount, cardTimelineId, cardGraphic, cardResponseRate, cardCurrentDay, cardTotalDays, cardActiveMilestonePosition, cardClick, dynamicCardWidth }) {

    const fetchTimelines = useFetchTimelines();

    const [areYouSureDeleteTimelineOpen, setAreYouSureDeleteTimelineOpen] = useState(false)



    const handleOpenTimelineDeleteModal = () => {

        setAreYouSureDeleteTimelineOpen(true);
    };
    const handleCloseTimelineDeleteModal = () => {

        //fetchTimelines.handleFetchAllTimelines(id);
        setAreYouSureDeleteTimelineOpen(false);


    };


    const {

        availableClientAuditEndDates, setAvailableClientAuditEndDates, handleUpdateAvailableClientAuditEndDates,
        activeClientAuditEndDates, setActiveClientAuditEndDates, handleUpdateActiveClientAuditEndDates,
        handleUpdateAvailableClientProjectTimelineData, handleUpdateTimelineMilestonesByBatchEndDate,
        reloadClientProjectTimelineData, setReloadClientProjectTimelineData, handleUpdateReloadClientProjectTimelineData,
        timelineSetupReload, setTimelineSetupReload,
        timelineDashboardReload, setTimelineDashboardReload
    } = useContext(ProjectDashboardContext);

    const [milestone1Active, setMilestone1Active] = useState(true);
    const [milestone2Active, setMilestone2Active] = useState(false);
    const [milestone3Active, setMilestone3Active] = useState(false);
    const [milestone4Active, setMilestone4Active] = useState(true);
    const [milestone5Active, setMilestone5Active] = useState(true);
    const [milestone6Active, setMilestone6Active] = useState(true);

    function handleUpdateMilestone1Active(update) {
        setMilestone1Active(update)
    }

    function handleUpdateMilestone2Active(update) {
        setMilestone2Active(update)
    }

    function handleUpdateMilestone3Active(update) {
        setMilestone3Active(update)
    }

    function handleUpdateMilestone4Active(update) {
        setMilestone4Active(update)
    }

    function handleUpdateMilestone5Active(update) {
        setMilestone5Active(update)
    }

    function handleUpdateMilestone6Active(update) {
        setMilestone6Active(update)
    }

    const [milestone1Title, setMilestone1Title] = useState("Initial NoticeDEF");
    const [milestone2Title, setMilestone2Title] = useState("ReminderDEF");
    const [milestone3Title, setMilestone3Title] = useState("DeadlineDEF");
    const [milestone4Title, setMilestone4Title] = useState("Final Notice + AppealsDEF");
    const [milestone5Title, setMilestone5Title] = useState("Final DeadlineDEF");
    const [milestone6Title, setMilestone6Title] = useState("ReportDEF");

    function handleMilestone1TitleChange(event) {
        setMilestone1Title(event.target.value)
    }
    function handleMilestone2TitleChange(event) {
        setMilestone2Title(event.target.value)
    }
    function handleMilestone3TitleChange(event) {
        setMilestone3Title(event.target.value)
    }
    function handleMilestone4TitleChange(event) {
        setMilestone4Title(event.target.value)
    }
    function handleMilestone5TitleChange(event) {
        setMilestone5Title(event.target.value)
    }
    function handleMilestone6TitleChange(event) {
        setMilestone6Title(event.target.value)
    }

    const [milestone1Goal, setMilestone1Goal] = useState(10);
    const [milestone2Goal, setMilestone2Goal] = useState(20);
    const [milestone3Goal, setMilestone3Goal] = useState(50);
    const [milestone4Goal, setMilestone4Goal] = useState(70);
    const [milestone5Goal, setMilestone5Goal] = useState(90);
    const [milestone6Goal, setMilestone6Goal] = useState(100);

    function handleMilestone1GoalUpdate(event) {

        if (event.target.value !== null) {
            setMilestone1Goal(event.target.value)
        }

    }

    function handleMilestone2GoalUpdate(event) {

        if (event.target.value !== null) {
            setMilestone2Goal(event.target.value)
        }

    }

    function handleMilestone3GoalUpdate(event) {

        if (event.target.value !== null) {
            setMilestone3Goal(event.target.value)
        }

    }

    function handleMilestone4GoalUpdate(event) {

        if (event.target.value !== null) {
            setMilestone4Goal(event.target.value)
        }

    }

    function handleMilestone5GoalUpdate(event) {

        if (event.target.value !== null) {
            setMilestone5Goal(event.target.value)
        }

    }

    function handleMilestone6GoalUpdate(event) {

        if (event.target.value !== null) {
            setMilestone6Goal(event.target.value)
        }

    }

    const [milestone1EndDateValue, setMilestone1EndDateValue] = useState(null);
    const [milestone2EndDateValue, setMilestone2EndDateValue] = useState(null);
    const [milestone3EndDateValue, setMilestone3EndDateValue] = useState(null);
    const [milestone4EndDateValue, setMilestone4EndDateValue] = useState(null);
    const [milestone5EndDateValue, setMilestone5EndDateValue] = useState(null);
    const [milestone6EndDateValue, setMilestone6EndDateValue] = useState(null);


    function handleMilestone1EndDateValueUpdate(value) {

        if (value !== null) {
            setMilestone1EndDateValue(value)
        }

    }

    function handleMilestone2EndDateValueUpdate(value) {

        if (value !== null) {
            setMilestone2EndDateValue(value)
        }

    }

    function handleMilestone3EndDateValueUpdate(value) {

        if (value !== null) {
            setMilestone3EndDateValue(value)
        }

    }

    function handleMilestone4EndDateValueUpdate(value) {

        if (value !== null) {
            setMilestone4EndDateValue(value)
        }

    }

    function handleMilestone5EndDateValueUpdate(value) {

        if (value !== null) {
            setMilestone5EndDateValue(value)
        }

    }

    function handleMilestone6EndDateValueUpdate(value) {

        if (value !== null) {
            setMilestone6EndDateValue(value)
        }

    }

    const [milestone1TotalDays, setMilestone1TotalDays] = useState(0);
    const [milestone2TotalDays, setMilestone2TotalDays] = useState(0);
    const [milestone3TotalDays, setMilestone3TotalDays] = useState(0);
    const [milestone4TotalDays, setMilestone4TotalDays] = useState(0);
    const [milestone5TotalDays, setMilestone5TotalDays] = useState(0);
    const [milestone6TotalDays, setMilestone6TotalDays] = useState(0);

    const [milestone1DaysComplete, setMilestone1DaysComplete] = useState(0);
    const [milestone2DaysComplete, setMilestone2DaysComplete] = useState(0);
    const [milestone3DaysComplete, setMilestone3DaysComplete] = useState(0);
    const [milestone4DaysComplete, setMilestone4DaysComplete] = useState(0);
    const [milestone5DaysComplete, setMilestone5DaysComplete] = useState(0);
    const [milestone6DaysComplete, setMilestone6DaysComplete] = useState(0);


    const [milestone1CurrentlyActive, setMilestone1CurrentlyActive] = useState(false);
    const [milestone2CurrentlyActive, setMilestone2CurrentlyActive] = useState(false);
    const [milestone3CurrentlyActive, setMilestone3CurrentlyActive] = useState(false);
    const [milestone4CurrentlyActive, setMilestone4CurrentlyActive] = useState(false);
    const [milestone5CurrentlyActive, setMilestone5CurrentlyActive] = useState(false);
    const [milestone6CurrentlyActive, setMilestone6CurrentlyActive] = useState(false);


    const [milestone1Complete, setMilestone1Complete] = useState(false);
    const [milestone2Complete, setMilestone2Complete] = useState(false);
    const [milestone3Complete, setMilestone3Complete] = useState(false);
    const [milestone4Complete, setMilestone4Complete] = useState(false);
    const [milestone5Complete, setMilestone5Complete] = useState(false);
    const [milestone6Complete, setMilestone6Complete] = useState(false);

    const [milestone1Id, setMilestone1Id] = useState("");
    const [milestone2Id, setMilestone2Id] = useState("");
    const [milestone3Id, setMilestone3Id] = useState("");
    const [milestone4Id, setMilestone4Id] = useState("");
    const [milestone5Id, setMilestone5Id] = useState("");
    const [milestone6Id, setMilestone6Id] = useState("");

    const [milestone1TypeId, setMilestone1TypeId] = useState("");
    const [milestone2TypeId, setMilestone2TypeId] = useState("");
    const [milestone3TypeId, setMilestone3TypeId] = useState("");
    const [milestone4TypeId, setMilestone4TypeId] = useState("");
    const [milestone5TypeId, setMilestone5TypeId] = useState("");
    const [milestone6TypeId, setMilestone6TypeId] = useState("");






    function getFormattedEditMilesstoneData(cardMilestoneData) {
        const newMap = cardMilestoneData?.map((item) => {
            if (item?.milestonePosition === 0) {
                setMilestone1Active(item.milestoneToggleActive)
                setMilestone1Title(item.milestoneLabel)
                setMilestone1Goal(item.milestoneGoal)
                setMilestone1EndDateValue(dayjs(item.milestoneEndDate))
                setMilestone1TotalDays(item.milestoneTotalDays)
                setMilestone1CurrentlyActive(item.activeMilestone)
                setMilestone1Complete(item.completedMilestone)
                setMilestone1DaysComplete(item.milestoneDaysComplete)
                setMilestone1Id(item.milestoneId)
                setMilestone1TypeId(item.milestoneTypeId)
            } else if (item?.milestonePosition === 1) {
                setMilestone2Active(item.milestoneToggleActive)
                setMilestone2Title(item.milestoneLabel)
                setMilestone2Goal(item.milestoneGoal)
                setMilestone2EndDateValue(dayjs(item.milestoneEndDate))
                setMilestone2TotalDays(item.milestoneTotalDays)
                setMilestone2CurrentlyActive(item.activeMilestone)
                setMilestone2Complete(item.completedMilestone)
                setMilestone2DaysComplete(item.milestoneDaysComplete)
                setMilestone2Id(item.milestoneId)
                setMilestone2TypeId(item.milestoneTypeId)
            } else if (item?.milestonePosition === 2) {
                setMilestone3Active(item.milestoneToggleActive)
                setMilestone3Title(item.milestoneLabel)
                setMilestone3Goal(item.milestoneGoal)
                setMilestone3EndDateValue(dayjs(item.milestoneEndDate))
                setMilestone3TotalDays(item.milestoneTotalDays)
                setMilestone3CurrentlyActive(item.activeMilestone)
                setMilestone3Complete(item.completedMilestone)
                setMilestone3DaysComplete(item.milestoneDaysComplete)
                setMilestone3Id(item.milestoneId)
                setMilestone3TypeId(item.milestoneTypeId)
            } else if (item?.milestonePosition === 3) {
                setMilestone4Active(item.milestoneToggleActive)
                setMilestone4Title(item.milestoneLabel)
                setMilestone4Goal(item.milestoneGoal)
                setMilestone4EndDateValue(dayjs(item.milestoneEndDate))
                setMilestone4TotalDays(item.milestoneTotalDays)
                setMilestone4CurrentlyActive(item.activeMilestone)
                setMilestone4Complete(item.completedMilestone)
                setMilestone4DaysComplete(item.milestoneDaysComplete)
                setMilestone4Id(item.milestoneId)
                setMilestone4TypeId(item.milestoneTypeId)
            } else if (item?.milestonePosition === 4) {
                setMilestone5Active(item.milestoneToggleActive)
                setMilestone5Title(item.milestoneLabel)
                setMilestone5Goal(item.milestoneGoal)
                setMilestone5EndDateValue(dayjs(item.milestoneEndDate))
                setMilestone5TotalDays(item.milestoneTotalDays)
                setMilestone5CurrentlyActive(item.activeMilestone)
                setMilestone5Complete(item.completedMilestone)
                setMilestone5DaysComplete(item.milestoneDaysComplete)
                setMilestone5Id(item.milestoneId)
                setMilestone5TypeId(item.milestoneTypeId)
            } else if (item?.milestonePosition === 5) {
                setMilestone6Active(item.milestoneToggleActive)
                setMilestone6Title(item.milestoneLabel)
                setMilestone6Goal(item.milestoneGoal)
                setMilestone6EndDateValue(dayjs(item.milestoneEndDate))
                setMilestone6TotalDays(item.milestoneTotalDays)
                setMilestone6CurrentlyActive(item.activeMilestone)
                setMilestone6Complete(item.completedMilestone)
                setMilestone6DaysComplete(item.milestoneDaysComplete)
                setMilestone6Id(item.milestoneId)
                setMilestone6TypeId(item.milestoneTypeId)
            }
            return "";


        })
    }


    const { id, auditName, auditFamilyId, employeeId } = useParams();


    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => {

        fetchTimelines.handleFetchAllTimelines(id);
        getFormattedEditMilesstoneData(cardMilestoneData)

        setOpenModal(true);
    };
    const handleCloseModal = () => {

        //fetchTimelines.handleFetchAllTimelines(id);
        setReloadClientProjectTimelineData(true);

        setOpenModal(false);
    };

    const {
        graphComponentData,
        handleUpdateGraphComponentData,
        graphTableComponentData,
        handleUpdateGraphTableComponentData
    } = useContext(GraphDetailsContext);

    const navigate = useNavigate();

    const [projectTimelineData, setProjectTimelineData] = useState([]);

    function handleUpdateProjectTimelineData(update) {
        if (update !== null) {
            setProjectTimelineData(update)
        }
    }






    const { accounts, instance } = useMsal();

    function handleChangeSortValueGlobal() {
        console.log("G Pre-sort value: ", cardBatchEndDate)

        //const newG = parseISO(cardBatchEndDate);

        const isoDate = cardBatchEndDate;
        const formattedDate = dayjs(isoDate).format('MM/DD/YYYY');

        let newMainList = [];

        if (cardClick === true) {
            console.log("G Post-sort value: ", formattedDate)

            const newSortValue = { auditEndDate: formattedDate };

            newMainList = [...newMainList, newSortValue];

            handleUpdateActiveClientAuditEndDates(newMainList);

        }



    }






    function handleGenerateNewTimeline() {
        console.log("VALUES: milestone1: Active:", milestone1Active, "milestone1Title: ", milestone1Title, "milestone1EndDate: ", milestone1EndDateValue, "milestone1Goal: ", milestone1Goal)
        console.log("VALUES: milestone2: Active:", milestone2Active, "milestone1Title: ", milestone2Title, "milestone1EndDate: ", milestone2EndDateValue, "milestone1Goal: ", milestone2Goal)

        console.log("VALUES: milestone3: Active:", milestone3Active, "milestone1Title: ", milestone3Title, "milestone1EndDate: ", milestone3EndDateValue, "milestone1Goal: ", milestone3Goal)

        console.log("VALUES: milestone4: Active:", milestone4Active, "milestone1Title: ", milestone4Title, "milestone1EndDate: ", milestone4EndDateValue, "milestone1Goal: ", milestone4Goal)

        console.log("VALUES: milestone5: Active:", milestone5Active, "milestone1Title: ", milestone5Title, "milestone1EndDate: ", milestone5EndDateValue, "milestone1Goal: ", milestone5Goal)

        console.log("VALUES: milestone6: Active:", milestone6Active, "milestone1Title: ", milestone6Title, "milestone1EndDate: ", milestone6EndDateValue, "milestone1Goal: ", milestone6Goal)


        let newMilestoneData = [];

        if (milestone1Active !== null) {
            let i = newMilestoneData?.length;
            let newItemID = i + 1;

            const newMilestoneDataItem = {
                "milestonePosition": i,
                "milestoneId": milestone1Id,
                "milestoneTypeId": milestone1TypeId,
                "milestoneToggleActive": milestone1Active,
                "milestoneLabel": milestone1Title,
                "milestoneEndDate": dayjs(milestone1EndDateValue).hour(0),
                "milestoneGoal": milestone1Goal,



            };
            newMilestoneData = [...newMilestoneData, newMilestoneDataItem];
        }

        if (milestone2Active !== null) {
            let i = newMilestoneData?.length;
            let newItemID = i + 1;

            const newMilestoneDataItem = {
                "milestonePosition": i,
                "milestoneId": milestone2Id,
                "milestoneTypeId": milestone2TypeId,
                "milestoneToggleActive": milestone2Active,
                "milestoneLabel": milestone2Title,
                "milestoneEndDate": dayjs(milestone2EndDateValue).hour(0),
                "milestoneGoal": milestone2Goal,

            };
            newMilestoneData = [...newMilestoneData, newMilestoneDataItem];
        }

        if (milestone3Active !== null) {
            let i = newMilestoneData?.length;
            let newItemID = i + 1;

            const newMilestoneDataItem = {
                "milestonePosition": i,
                "milestoneId": milestone3Id,
                "milestoneTypeId": milestone3TypeId,
                "milestoneToggleActive": milestone3Active,
                "milestoneLabel": milestone3Title,
                "milestoneEndDate": dayjs(milestone3EndDateValue).hour(0),
                "milestoneGoal": milestone3Goal,

            };
            newMilestoneData = [...newMilestoneData, newMilestoneDataItem];
        }

        if (milestone4Active !== null) {
            let i = newMilestoneData?.length;
            let newItemID = i + 1;

            const newMilestoneDataItem = {
                "milestonePosition": i,
                "milestoneId": milestone4Id,
                "milestoneTypeId": milestone4TypeId,
                "milestoneToggleActive": milestone4Active,
                "milestoneLabel": milestone4Title,
                "milestoneEndDate": dayjs(milestone4EndDateValue).hour(0),
                "milestoneGoal": milestone4Goal,

            };
            newMilestoneData = [...newMilestoneData, newMilestoneDataItem];
        }

        if (milestone5Active !== null) {
            let i = newMilestoneData?.length;
            let newItemID = i + 1;

            const newMilestoneDataItem = {
                "milestonePosition": i,
                "milestoneId": milestone5Id,
                "milestoneTypeId": milestone5TypeId,
                "milestoneToggleActive": milestone5Active,
                "milestoneLabel": milestone5Title,
                "milestoneEndDate": dayjs(milestone5EndDateValue).hour(0),
                "milestoneGoal": milestone5Goal,

            };
            newMilestoneData = [...newMilestoneData, newMilestoneDataItem];
        }

        if (milestone6Active !== null) {
            let i = newMilestoneData?.length;
            let newItemID = i + 1;

            const newMilestoneDataItem = {
                "milestonePosition": i,
                "milestoneId": milestone6Id,
                "milestoneTypeId": milestone6TypeId,
                "milestoneToggleActive": milestone6Active,
                "milestoneLabel": milestone6Title,
                "milestoneEndDate": dayjs(milestone6EndDateValue).hour(0),
                "milestoneGoal": milestone6Goal,

            };
            newMilestoneData = [...newMilestoneData, newMilestoneDataItem];
        }

        console.log("NEW MILESTONE DATA: ", newMilestoneData);

        setProjectTimelineData([
            {
                "auditId": id,
                "batchEndDate": cardBatchEndDate,
                "timelineId": cardTimelineId,
                "familyStartId": cardFamilyStartId,
                "familyEndId": cardFamilyEndId,
                "totalCount": cardTotalCount,
                "active": true,
                "timelineResponseRate": cardResponseRate,
                "newTimeline": false,
                "timelineTotalDays": cardTotalDays,
                "timelineCurrentDay": cardCurrentDay,
                "activeMilestonePosition": cardActiveMilestonePosition,
                "milestones": newMilestoneData,

            }
        ])

        //update state through context
        //handleUpdateTimelineMilestonesByBatchEndDate(cardBatchEndDate, newMilestoneData)
        //handleUpdateReloadClientProjectTimelineData(true);


        ///TODO - Call thing that actually updates the network resource for project timelines by client ID (currently being built else where)

        function submitUserData() {
            instance.acquireTokenSilent({ loginRequest, account: instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) })
                .then(result => {
                    //console.log("WOAH YEAH EDIT - ", JSON.stringify({
                    //    "timelineId": cardTimelineId,
                    //    "auditId": parseInt(id),
                    //    "batchEndDate": cardBatchEndDate !== null ? cardBatchEndDate : "(Data Not Yet Available)",
                    //    "milestoneStartDate": milestone1EndDateValue,
                    //    "milestoneEndDate": milestone6EndDateValue,
                    //    "active": true,
                    //    "milestones": newMilestoneData,
                    //}))
                    const fetchData = () => {
                        fetch(process.env.REACT_APP_BACK_URL + '/api/Timeline/UpdateTimeline', {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + result.idToken,
                            },
                            body: JSON.stringify({
                                "timelineId": cardTimelineId,
                                "auditId": parseInt(id),
                                "batchEndDate": cardBatchEndDate !== null ? cardBatchEndDate : "(Data Not Yet Available)",
                                "milestoneStartDate": milestone1EndDateValue,
                                "milestoneEndDate": milestone6EndDateValue,
                                "active": true,
                                "milestones": newMilestoneData,
                            })
                          

                        })

                            .then(res => res.json())
                            .then((response) => {
                                console.log(response)
                                setOpenModal(false);
                                //call get timelines fetch request

                            }).catch((error) => {
                                console.log(error)
                                //throw error if submission fails
                            })


                    }

                    fetchData();

                }).catch((error) => {
                    console.log(error) //token expired/is not valid => user is redirected to login page
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect({ loginRequest, account: instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) });
                    }

                });

        }
        submitUserData();


        fetchTimelines.handleFetchAllTimelines(id);

        if (activeClientAuditEndDates !== [{
            auditEndDate: "12/12/1800"
        }]) {
            setActiveClientAuditEndDates(activeClientAuditEndDates)
        }

        //getFormattedEditMilesstoneData(cardMilestoneData)
        setTimelineSetupReload(true);
        setTimelineDashboardReload(true);
        setReloadClientProjectTimelineData(true)
        //getFormattedEditMilesstoneData(newMilestoneData)

        handleCloseModal(false);


        //close modal
        //setOpenModal(false);



        //setMainSearchFilterModel([])
        //apiRef.current.setFilterModel({
        //    items: []

        //});



        //handleGetAndSetAllFiltersForUpdate()
    }






    useEffect(() => {
        getFormattedEditMilesstoneData(cardMilestoneData)

    }, [])

    //potentially remove 

    useEffect(() => {
        console.log("New Timeline updated data: ", projectTimelineData)
        handleUpdateReloadClientProjectTimelineData(true);
    }, [projectTimelineData])

    function handleClearTimeline() {
        console.log("DELETE - CLEAR TIMELINE");
        //CLEAR TIMELINE

        instance.acquireTokenSilent({ loginRequest, account: instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) })
            .then(result => {
                console.log("WOAH YEAH DELETE EDIT")
                const fetchData = () => {
                    fetch(process.env.REACT_APP_BACK_URL + '/api/Timeline/DeleteTimeline', {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + result.idToken,
                        },
                        body: JSON.stringify({
                            "timelineId": cardTimelineId,
                            "auditId": id,
                            "batchEndDate": cardBatchEndDate !== null ? cardBatchEndDate : "(Data Not Yet Available)",

                        })
                        //"auditId": id,
                        //"batchEndDate": cardBatchEndDate !== null ? cardBatchEndDate : "(Data Not Yet Available)",
                        //"MilestonesStartDate": milestone1EndDateValue,
                        //"MilestonesEndDate": milestone6EndDateValue,
                        //"milestones": newMilestoneData,
                        //projectTimelineData

                    })

                        .then(res => res.json())
                        .then((response) => {
                            console.log(response)
                            setOpenModal(false);
                            //call get timelines fetch request

                        }).catch((error) => {
                            console.log(error)
                            //throw error if submission fails
                        })


                }

                fetchData();

            }).catch((error) => {
                console.log(error) //token expired/is not valid => user is redirected to login page
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect({ loginRequest, account: instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) });
                }

            });

        fetchTimelines.handleFetchAllTimelines(id);
        //getFormattedEditMilesstoneData(cardMilestoneData)
        setTimelineSetupReload(true);
        setTimelineDashboardReload(true);
        setReloadClientProjectTimelineData(true)

        handleCloseModal(false);

    }









    /*let stringedStateObj = JSON.stringify(stateObj)*/



    return (
        <>

            <Card style={{ height: desiredHeightPercentage != null ? (desiredHeightPercentage) : ('90%') }}
                onClick={handleChangeSortValueGlobal}
                sx={{
                    mr: '20%',
                    mb: 1.5,

                    minHeight: desiredCardHeight ? (desiredCardHeight) : (400),
                    height: desiredCardHeight ? (desiredCardHeight) : (400),
                    minWidth: dynamicCardWidth === true ? (`${(cardTotalDays * 4)}`) : (desiredCardWidth),
                    width: dynamicCardWidth === true ? (`${(cardTotalDays * 4)}`) : (desiredCardWidth)

                }}>


                {cardType == 'generic' ? (<>
                    {cardGraphic !== null ? (<>
                        <Typography sx={{ mt: 1 }} textAlign="center" variant="h6" fontWeight="700" fontSize="0.9em" component="div">

                            <div style={{ textAlign: 'center', fontSize: '300%', color: '#233cb0' }}>{cardGraphic}</div>

                        </Typography>

                    </>) : (<></>)}
                    <Typography sx={{ mt: 0 }} textAlign="center" variant="h6" fontWeight="700" fontSize="0.9em" component="div">

                        {cardTitle}

                    </Typography>

                    <Typography sx={{ mt: 1 }} textAlign="center" variant="h6" fontWeight="500" fontSize="0.8em" component="div">

                        {cardSubtitle}

                    </Typography>

                    {/* <Button onClick={handleOpenModal} sx={{ ml: "45.5%", mt: 1.5, bgcolor: '#233cb0', fontWeight: '700', width: '2VW' }} variant="contained">Start</Button>*/}

                </>) : (<></>)}

                {cardType == 'audit' ? (<>
                    <div className="row-no-margin">
                        <Typography sx={{ mt: 2, ml: 2 }} textAlign="left" variant="h6" fontWeight="700" fontSize="0.9em" component="div">

                            {cardTitle}

                        </Typography>
                        <Typography sx={{ mt: 2, ml: 2, color: cardChipStatus === 'unset' ? "" : '#A3A3A3' }} textAlign="left" variant="h6" fontWeight="500" fontSize="0.8em" component="div">

                            {cardSubtitle}

                        </Typography>

                        {cardExtraSubtitle !== null ? (<>
                            <Typography sx={{ mt: 2, ml: 2, color: cardChipStatus === 'unset' ? "" : '#A3A3A3' }} textAlign="left" variant="h6" fontWeight="500" fontSize="0.8em" component="div">

                                {cardExtraSubtitle}

                            </Typography>
                        </>) : (<></>)}

                        {/*{dynamicCardWidth === true ? (<>*/}
                        {/*    <Typography sx={{ mt: 2, ml: 2, color: cardChipStatus === 'unset' ? "" : '#A3A3A3' }} textAlign="left" variant="h6" fontWeight="500" fontSize="0.8em" component="div">*/}

                        {/*        D:{cardTotalDays}*/}

                        {/*    </Typography>*/}
                        {/*</>) : (<></>)}*/}
                        <div className="row-right">
                            {/*                            <Chip variant={cardChipStatus === 'unset' ? "outlined" : ""} color={cardChipStatus === 'unset' ? "warning" : "success"} label={cardChipLabel} sx={{ color: cardChipStatus === 'unset' ? "#EA580C" : "", bgcolor: cardChipStatus === 'unset' ? "" : "#2DD4BF", mr: 1, mt: '2.5VH', fontWeight: '700' }} />*/}
                            <div className="row-no-left-margin">
                                <div className="row-right">
                                    <Button onClick={handleOpenModal} sx={{ mt: cardChipStatus === 'unset' ? 0 : 0, mr: 1.5, bgcolor: '#233cb0', fontWeight: '700', width: '2VW' }} variant="contained">{cardChipStatus === 'unset' ? 'Start' : 'Edit'}</Button>
                                    {/*<Button onClick={handleOpenModal} sx={{ mt: cardChipStatus === 'unset' ? 0 : 0, mr: 1.5, bgcolor: '#A3A3A3', color: '#000000DE', fontWeight: '700', width: '2VW' }} variant="contained">{cardChipStatus === 'unset' ? 'Start' : 'Edit'}</Button>*/}
                                </div>
                            </div>
                        </div>


                    </div>




                    {cardExtraSubtitle2 !== null ? (<>
                        <Typography sx={{ mt: 3 }} textAlign="center" variant="h6" fontWeight="700" fontSize="0.9em" component="div">

                            {cardExtraSubtitle2}

                        </Typography>
                    </>) : (<></>)}

                    {cardResponseRate !== null ? (<>
                        <div className="row-no-margin">
                            {/* NEED SPACE FOR RESPONSE RATE GRAPH AND TIMELINE CONTAINER  */}
                            <CircularProgressWithLabel value={cardResponseRate} />
                            <Box sx={{ width: "3.15VW" }}></Box>
                            {cardMilestoneData !== null ? (<>
                                {cardMilestoneData?.map((item) => {
                                    if (item.milestoneToggleActive === true) {
                                        return (<Box sx={{ mt: "-2VH", ml: 0, mr: 0, width: item.milestoneTotalDays >= 7 ? `${(2.75 * (item.milestoneTotalDays / 7)) + 2.35}VW` : "5VW" && item.milestoneLabel === "Wrap-up Period" ? `${(2.75 * (item.milestoneTotalDays / 7)) + 5.05}VW` : "5VW", }}>
                                            <Box sx={{ position: "relative", mb: "1.25VH" }}>
                                                <Typography sx={{ mt: '-0.75VH', ml: item.milestonePosition === 0 ? "-1VW" : "-1.5VW" && item.milestonePosition === 5 ? "-1VW" : "-1.5VW", mr: "0%", color: cardChipStatus === 'unset' ? "" : '#A3A3A3' }} textAlign="left" variant="h6" fontWeight="500" fontSize="0.8em" component="div">

                                                    {dayjs(item.milestoneEndDate).format("MM/DD")}

                                                </Typography>
                                            </Box>
                                            <Box sx={{ mt: "-2VH", ml: 0, width: item.milestoneTotalDays >= 7 ? `${(2.75 * (item.milestoneTotalDays / 7)) + 3.08}VW` : "5VW" && item.milestoneLabel === "Wrap-up Period" ? `${(2.75 * (item.milestoneTotalDays / 7)) + 6.25}VW` : "5VW", height: "1VH" }}>
                                                <Typography sx={{ zIndex: 10, mt: '2VH', mb: 0, ml: item.milestoneLabel === "Initial Notice" ? `0VW` : "0.00VW" && item.milestoneLabel === "Reminder" ? "0VW" : "0VW" && item.milestoneLabel === "Final Deadline" ? "-0.0VW" : "0VW" && item.milestoneLabel === "Deadline" ? "0VW" : "0VW" && item.milestoneLabel === "Wrap-up Period" ? `-0.2VW` : "0.00VW", mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: item.activeMilestone === true ? "" : '#A3A3A3' }} textAlign="left" variant="h6" fontWeight="500" fontSize="0.8em" component="div">

                                                    {item.milestoneLabel}

                                                </Typography>
                                            </Box>
                                            {item.completedMilestone === true ? (<>
                                                <Box sx={{ position: "relative", ml: "0VW", mt: "1VH" }}>
                                                    {item.milestonePosition !== 5 ? (<>
                                                        <BorderLinearProgress variant="determinate" value={100} sx={{ width: item.milestoneTotalDays !== 1 ? `${3 * (item.milestoneTotalDays / 7)}VW` : "0.5VW" }} />

                                                    </>) : (<>
                                                        <BorderLinearProgressTealTwo variant="determinate" value={100} sx={{ width: item.milestoneTotalDays !== 1 ? `${3 * (item.milestoneTotalDays / 7)}VW` : "0.5VW" }} />

                                                    </>)}
                                                </Box>
                                            </>) : (<>
                                                {item.completedMilestone === false && item.activeMilestone === true ? (<>
                                                        <Box sx={{ position: "relative", ml: "0VW", mt: "1VH" }}>
                                                  
                                                            <LightTooltipTimeline sx={{ width: "20VW", }} slotProps={{
                                                            popper: {
                                                                modifiers: [

                                                                    {
                                                                        name: 'offset',
                                                                        options: {
                                                                            offset: [64, 24],

                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        }} placement="top" title={
                                                            <>
                                                                <div className="row-no-margin">
                                                                    <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '2VW', mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: '#64748B' }} textAlign="left" variant="h6" fontWeight="400" fontSize="14px" component="div">

                                                                        Current Day

                                                                    </Typography>
                                                                    <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '0.5VW', mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: '#020617' }} textAlign="left" variant="h6" fontWeight="700" fontSize="16px" component="div">

                                                                        {dayjs(new Date()).format("MM/DD")}

                                                                    </Typography>
                                                                </div>
                                                                <Divider variant="middle" />
                                                                <div className="row-no-margin">
                                                                    <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '2VW', mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: '#64748B' }} textAlign="left" variant="h6" fontWeight="400" fontSize="14px" component="div">

                                                                        Progress

                                                                    </Typography>
                                                                    <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '2.5VW', mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: '#64748B' }} textAlign="left" variant="h6" fontWeight="400" fontSize="14px" component="div">

                                                                        Goal

                                                                    </Typography>
                                                                </div>

                                                                <div className="row-no-margin">
                                                                    <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '2.5VW', mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: '#020617' }} textAlign="left" variant="h6" fontWeight="700" fontSize="16px" component="div">

                                                                        {cardResponseRate.toFixed(0)}%

                                                                    </Typography>
                                                                    <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '2.85VW', mr: "0%", fontWeight: item.activeMilestone === true ? "600" : '', color: '#020617' }} textAlign="left" variant="h6" fontWeight="700" fontSize="16px" component="div">

                                                                        {item.milestoneGoal}%

                                                                    </Typography>
                                                                </div>


                                                            </>
                                                        }>
                                                                <div>
                                                                {item.milestonePosition !== 5 ? (<>
                                                                    <BorderLinearProgress variant="determinate" value={(item.milestoneDaysComplete / item.milestoneTotalDays) * 100} sx={{ width: item.milestoneTotalDays !== 1 ? `${3 * (item.milestoneTotalDays / 7)}VW` : "0.5VW" }} />

                                                                </>) : (<>
                                                                    <BorderLinearProgressTealTwo variant="determinate" value={(item.milestoneDaysComplete / item.milestoneTotalDays) * 100} sx={{ width: item.milestoneTotalDays !== 1 ? `${3 * (item.milestoneTotalDays / 7)}VW` : "0.5VW" }} />

                                                                    </>)}
                                                                </div>

                                                                </LightTooltipTimeline>
                                                            
                                                    </Box>
                                                </>) : (<>
                                                            <Box sx={{ position: "relative", ml: "0VW", mt: "1VH" }}>
                                                                {item.milestonePosition !== 5 ? (<>
                                                                    <BorderLinearProgress variant="determinate" value={0} sx={{ width: item.milestoneTotalDays !== 1 ? `${3 * (item.milestoneTotalDays / 7)}VW` : "0.5VW" }} />

                                                                </>) : (<>
                                                                        <BorderLinearProgressTealTwo variant="determinate" value={0} sx={{ width: item.milestoneTotalDays !== 1 ? `${3 * (item.milestoneTotalDays / 7)}VW` : "0.5VW" }} />

                                                                </>)}
                                                       
                                                    </Box>
                                                </>)}
                                            </>)}





                                            {item.milestonePosition !== 5 ? (<>
                                                <Box sx={{ position: "relative", mt: "0.5VH" }}>
                                                    <Typography sx={{ mt: '-.05VH', ml: "0%", mr: "-2.0VW", color: cardChipStatus === 'unset' ? "" : '#A3A3A3' }} textAlign="right" variant="h6" fontWeight="500" fontSize="0.8em" component="div">

                                                        {`Goal: ${item.milestoneGoal}%`}

                                                    </Typography>
                                                </Box>
                                                <Divider orientation="vertical" variant="middle" position="absolute" sx={{ ml: "-0.45VW", mr: '0.55VW' && item.milestonePosition === 4 ? '0.05VW' : '0.55VW', mt: "-5.95VH", height: "3.85VH" }} />
                                            </>) : (<>

                                            </>)}

                                        </Box>)
                                    } else {
                                        return (<></>);
                                    }

                                })}
                            </>) : (<></>)}









                        </div>
                    </>) : (<></>)}




                </>) : (<></>)}



                {/*<div className="row-no-left-margin">*/}

                {/*    <div className="row-right">*/}




                {/*    </div>*/}

                {/*</div>*/}
                <Container sx={{ ml: '-4.5VW', mb: '-0.5VH', mt: '-4VH' }}>
                    <Grid container spacing={3} sx={{ mt: 0, mb: 0, display: { xs: 'none', md: 'flex', xl: 'flex' } }}>
                        <Grid item xs={4} >



                        </Grid>

                        <Grid item xs={8} >



                        </Grid>
                    </Grid>
                </Container>













            </Card>


            <BootstrapDialog
                fullWidth={true}
                maxWidth={'lg'}
                onClose={handleCloseModal}
                aria-labelledby="customized-dialog-title"
                open={openModal}
            >
                <BootstrapDialogTitle sx={{ fontWeight: 700, fontSize: '20px' }} id="customized-dialog-title" onClose={handleCloseModal}>
                    Edit Project Timeline - {cardTitle}
                    <div className="row-no-margin">
                        <div className="row-right">
                            <Button
                                sx={{
                                    mr: '6VW',
                                    mt: '-2VH',
                                    border: '1px solid #991B1B',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        bgcolor: '#FECACA'
                                    }

                                }}

                                onClick={handleOpenTimelineDeleteModal}

                            >
                                <Typography sx={{ color: '#991B1B' }}>
                                    Delete Timeline <HiOutlineTrash />
                                </Typography>


                            </Button>
                        </div>
                    </div>

                </BootstrapDialogTitle>
                <form

                >
                    <DialogContent>
                        {/*//FORM CONTENT GOES HERE*/}

                        {cardMilestoneData?.length !== 0 ? (<>
                            {cardMilestoneData?.map((itemx) => {


                                return (
                                    <>
                                        {/* 
                                        DEBUG
                                         <Typography sx={{ mt: 0.5, ml: 2, color: cardChipStatus === 'unset' ? "" : '#A3A3A3' }} textAlign="left" variant="h6" fontWeight="500" fontSize="0.8em" component="div">
                                            label:{itemx?.milestoneLabel}+EndDate:{dayjs(itemx?.milestoneEndDate).toString()}+Goal:{itemx?.milestoneGoal}+ToggleActive:{itemx?.milestoneToggleActive === true ? "true" : "false"}
                                        </Typography>

                                        */ }




                                    </>
                                )


                            })}

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone1Title}
                                    disabled={milestone1Active !== true ? true : false}
                                    onChange={handleMilestone1TitleChange}
                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone1EndDateValue}
                                        onChange={handleMilestone1EndDateValueUpdate}
                                        label={milestone1Title !== "" ? `${milestone1Title} Milestone Start Date` : 'Milestone Start Date'}
                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}
                                        disabled={milestone1Active !== true ? true : false}
                                    />

                                </LocalizationProvider>

                                {/*<TextField*/}
                                {/*    label="Date"*/}
                                {/*    variant="outlined"*/}
                                {/*    value={""}*/}


                                {/*    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}*/}


                                {/*/>*/}

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone1Active !== true ? true : false}
                                    label={milestone1Title !== "" ? `${milestone1Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone1Goal}

                                    onValueChange={(values) => {
                                        handleMilestone1GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />



                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone1Active(!milestone1Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone1Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>


                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone2Title}
                                    onChange={handleMilestone2TitleChange}
                                    disabled={milestone2Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone2EndDateValue}
                                        onChange={handleMilestone2EndDateValueUpdate}
                                        label={milestone2Title !== "" ? `${milestone2Title} Milestone Start Date` : 'Milestone Start Date'}
                                        disabled={milestone2Active !== true ? true : false}
                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone2Active !== true ? true : false}
                                    label={milestone2Title !== "" ? `${milestone2Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone2Goal}

                                    onValueChange={(values) => {
                                        handleMilestone2GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                <FormControlLabel
                                    onClick={() => handleUpdateMilestone2Active(!milestone2Active)}
                                    control={<IOSSwitch sx={{ m: 1 }} checked={milestone2Active} />}
                                    label="Active"
                                />

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone3Title}
                                    onChange={handleMilestone3TitleChange}
                                    disabled={milestone3Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone3EndDateValue}
                                        onChange={handleMilestone3EndDateValueUpdate}
                                        disabled={milestone3Active !== true ? true : false}
                                        label={milestone3Title !== "" ? `${milestone3Title} Milestone Start Date` : 'Milestone Start Date'}

                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone3Active !== true ? true : false}
                                    label={milestone3Title !== "" ? `${milestone3Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone3Goal}

                                    onValueChange={(values) => {
                                        handleMilestone3GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                <FormControlLabel
                                    onClick={() => handleUpdateMilestone3Active(!milestone3Active)}
                                    control={<IOSSwitch sx={{ m: 1 }} checked={milestone3Active} />}
                                    label="Active"
                                />

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone4Title}
                                    onChange={handleMilestone4TitleChange}
                                    disabled={milestone4Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone4EndDateValue}
                                        onChange={handleMilestone4EndDateValueUpdate}
                                        disabled={milestone4Active !== true ? true : false}
                                        label={milestone4Title !== "" ? `${milestone4Title} Milestone State Date` : 'Milestone State Date'}

                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone4Active !== true ? true : false}
                                    label={milestone4Title !== "" ? `${milestone4Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone4Goal}

                                    onValueChange={(values) => {
                                        handleMilestone4GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                <FormControlLabel
                                    onClick={() => handleUpdateMilestone4Active(!milestone4Active)}
                                    control={<IOSSwitch sx={{ m: 1 }} checked={milestone4Active} />}
                                    label="Active"
                                />

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone5Title}
                                    onChange={handleMilestone5TitleChange}
                                    disabled={milestone5Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone5EndDateValue}
                                        onChange={handleMilestone5EndDateValueUpdate}
                                        disabled={milestone5Active !== true ? true : false}
                                        label={milestone5Title !== "" ? `${milestone5Title} Milestone Start Date` : 'Milestone Start Date'}
                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone5Active !== true ? true : false}
                                    label={milestone5Title !== "" ? `${milestone5Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone5Goal}

                                    onValueChange={(values) => {
                                        handleMilestone5GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone5Active(!milestone5Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone5Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone6Title}
                                    onChange={handleMilestone6TitleChange}
                                    disabled={milestone6Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone6EndDateValue}
                                        onChange={handleMilestone6EndDateValueUpdate}
                                        disabled={milestone6Active !== true ? true : false}
                                        label={milestone6Title !== "" ? `${milestone6Title} Milestone End Date` : 'Milestone End Date'}

                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone6Active !== true ? true : false}
                                    label={milestone6Title !== "" ? `${milestone6Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone6Goal}

                                    onValueChange={(values) => {
                                        handleMilestone6GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone6Active(!milestone6Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone6Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>


                        </>) : (<>
                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone1Title}
                                    disabled={milestone1Active !== true ? true : false}
                                    onChange={handleMilestone1TitleChange}
                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone1EndDateValue}
                                        onChange={handleMilestone1EndDateValueUpdate}
                                        label={milestone1Title !== "" ? `${milestone1Title} Milestone End Date` : 'Milestone End Date'}
                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}
                                        disabled={milestone1Active !== true ? true : false}
                                    />

                                </LocalizationProvider>



                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone1Active !== true ? true : false}
                                    label={milestone1Title !== "" ? `${milestone1Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone1Goal}

                                    onValueChange={(values) => {
                                        handleMilestone1GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />



                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone1Active(!milestone1Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone1Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>


                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone2Title}
                                    onChange={handleMilestone2TitleChange}
                                    disabled={milestone2Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone2EndDateValue}
                                        onChange={handleMilestone2EndDateValueUpdate}
                                        label={milestone2Title !== "" ? `${milestone2Title} Milestone End Date` : 'Milestone End Date'}
                                        disabled={milestone2Active !== true ? true : false}
                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone2Active !== true ? true : false}
                                    label={milestone2Title !== "" ? `${milestone2Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone2Goal}

                                    onValueChange={(values) => {
                                        handleMilestone2GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                <FormControlLabel
                                    onClick={() => handleUpdateMilestone2Active(!milestone2Active)}
                                    control={<IOSSwitch sx={{ m: 1 }} checked={milestone2Active} />}
                                    label="Active"
                                />

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone3Title}
                                    onChange={handleMilestone3TitleChange}
                                    disabled={milestone3Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone3EndDateValue}
                                        onChange={handleMilestone3EndDateValueUpdate}
                                        disabled={milestone3Active !== true ? true : false}
                                        label={milestone3Title !== "" ? `${milestone3Title} Milestone End Date` : 'Milestone End Date'}

                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone3Active !== true ? true : false}
                                    label={milestone3Title !== "" ? `${milestone3Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone3Goal}

                                    onValueChange={(values) => {
                                        handleMilestone3GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                <FormControlLabel
                                    onClick={() => handleUpdateMilestone3Active(!milestone3Active)}
                                    control={<IOSSwitch sx={{ m: 1 }} checked={milestone3Active} />}
                                    label="Active"
                                />

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone4Title}
                                    onChange={handleMilestone4TitleChange}
                                    disabled={milestone4Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone4EndDateValue}
                                        onChange={handleMilestone4EndDateValueUpdate}
                                        disabled={milestone4Active !== true ? true : false}
                                        label={milestone4Title !== "" ? `${milestone4Title} Milestone End Date` : 'Milestone End Date'}

                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone4Active !== true ? true : false}
                                    label={milestone4Title !== "" ? `${milestone4Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone4Goal}

                                    onValueChange={(values) => {
                                        handleMilestone4GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone4Active(!milestone4Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone4Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone5Title}
                                    onChange={handleMilestone5TitleChange}
                                    disabled={milestone5Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone5EndDateValue}
                                        onChange={handleMilestone5EndDateValueUpdate}
                                        disabled={milestone5Active !== true ? true : false}
                                        label={milestone5Title !== "" ? `${milestone5Title} Milestone End Date` : 'Milestone End Date'}
                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone5Active !== true ? true : false}
                                    label={milestone5Title !== "" ? `${milestone5Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone5Goal}

                                    onValueChange={(values) => {
                                        handleMilestone5GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone5Active(!milestone5Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone5Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>

                            <div className="modal-row">
                                <TextField
                                    label="Milestone Title"
                                    variant="outlined"
                                    value={milestone6Title}
                                    onChange={handleMilestone6TitleChange}
                                    disabled={milestone6Active !== true ? true : false}

                                    sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }}


                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={milestone6EndDateValue}
                                        onChange={handleMilestone6EndDateValueUpdate}
                                        disabled={milestone6Active !== true ? true : false}
                                        label={milestone6Title !== "" ? `${milestone6Title} Milestone End Date` : 'Milestone End Date'}

                                        sx={{ mr: '1VW', width: '16VW', bgcolor: '#FFFFFF' }} />

                                </LocalizationProvider>

                                <NumericFormat
                                    customInput={TextField}
                                    {...materialUITextFieldProps}
                                    disabled={milestone6Active !== true ? true : false}
                                    label={milestone6Title !== "" ? `${milestone6Title} Milestone Goal` : 'Milestone Goal'}
                                    value={milestone6Goal}

                                    onValueChange={(values) => {
                                        handleMilestone6GoalUpdate({ target: { value: values.value } })
                                    }

                                    }



                                    valueIsNumericString={true}
                                    suffix="%"
                                />

                                {/*<FormControlLabel*/}
                                {/*    onClick={() => handleUpdateMilestone6Active(!milestone6Active)}*/}
                                {/*    control={<IOSSwitch sx={{ m: 1 }} checked={milestone6Active} />}*/}
                                {/*    label="Active"*/}
                                {/*/>*/}

                            </div>
                        </>)}



                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" autoFocus onClick={handleCloseModal}>
                            Cancel
                        </Button>
                        <Button
                            onClick={() => handleGenerateNewTimeline()}
                            variant="contained"

                            autoFocus>
                            Save
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>

            <Dialog
                open={areYouSureDeleteTimelineOpen}
                onClose={handleCloseTimelineDeleteModal}

            >
                <DialogTitle id="alert-dialog-title" >
                    Delete Timeline?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This will remove the Timeline for {cardTitle}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" onClick={handleCloseTimelineDeleteModal}>Cancel</Button>
                    <Button variant="contained"
                        sx={{
                            bgcolor: '#ffffff', color: '#991B1B',
                            border: '1px solid #991B1B',
                            '&:hover': {
                                cursor: 'pointer',
                                bgcolor: '#FECACA'
                            }
                        }}
                        onClick={() => handleClearTimeline()}
                        autoFocus
                    >
                        Delete
                        <HiOutlineTrash />
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default EditTimelineCard;

